import { render, staticRenderFns } from "./EditHall.vue?vue&type=template&id=2aa595ef&scoped=true&"
import script from "./EditHall.vue?vue&type=script&lang=js&"
export * from "./EditHall.vue?vue&type=script&lang=js&"
import style0 from "./EditHall.vue?vue&type=style&index=0&id=2aa595ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa595ef",
  null
  
)

component.options.__file = "EditHall.vue"
export default component.exports